import { useContext } from 'react'

import {
  mapExperienceTicketSelections,
} from '../utils'

import {
  tripLoginModalSignUpDismiss,
  tripLoginModalSignUpView,
} from 'analytics/eventDefinitions'
import { fireInteractionEvent } from 'api/googleTagManager'
import ExperienceOfferPageStateContext from 'contexts/Experience/ExperienceOfferPage/experienceOfferPageStateContext'
import { useCurrentExperiencePageTicketOptions } from 'hooks/ExperiencePage/useCurrentExperiencePageTicketOptions'
import { useIsExperienceBookmarkHidden } from 'tripPlanner/contexts/ExperienceBookmarkVisibilityContext'
import WishlistOfferBookmarkButton from 'wishlists/components/WishlistOfferBookmarkButton'
import { useExperienceWishlistDisplayFields } from 'wishlists/hooks/useWishlistDisplayFields'

export interface Props {
  offer: App.ExperienceOffer
  withLabel?: React.ComponentProps<typeof WishlistOfferBookmarkButton>['withLabel']
  size?: React.ComponentProps<typeof WishlistOfferBookmarkButton>['size']
}

const trackTripLoginModalSignUpView = () => {
  fireInteractionEvent(tripLoginModalSignUpView('save'))
}
const trackTripLoginModalSignUpDismiss = () => {
  fireInteractionEvent(tripLoginModalSignUpDismiss('save'))
}

function ExperienceBookmarkButton({ offer, withLabel, size }: Props) {
  const wishlistDisplayFields = useExperienceWishlistDisplayFields(offer)
  const experienceOfferPageState = useContext(ExperienceOfferPageStateContext)
  const isHidden = useIsExperienceBookmarkHidden()

  const allTicketOptions = useCurrentExperiencePageTicketOptions(
    offer.id,
    experienceOfferPageState,
  )

  if (isHidden) return null

  return (
    <WishlistOfferBookmarkButton
      item={{
        type: 'experience',
        code: offer.id,
        languageId: experienceOfferPageState.language?.id,
        pickupPointId: experienceOfferPageState.pickupPoint?.id,
        redemptionLocationId: experienceOfferPageState.redemptionLocation?.id,
        startDate: experienceOfferPageState.date,
        startTime: experienceOfferPageState.time,
        tickets: mapExperienceTicketSelections(
          experienceOfferPageState,
          allTicketOptions,
        ),
      }}
      {...wishlistDisplayFields}
      withLabel={withLabel}
      size={size}
      onShowLogin={trackTripLoginModalSignUpView}
      onDismissLogin={trackTripLoginModalSignUpDismiss}
    />
  )
}

export default ExperienceBookmarkButton
